import { vehicleStatusActionSelectors as selector } from "../Selectors/index";

export const vehicleStatusReducer = (state = [], { type, payload }) => {
  switch (type) {
    case selector.GET_VEHICLE_STATUS:
      return payload;

    default:
      return state;
  }
};
